/**
 * Client-side photo offload — before any inspection save, large base64 photos
 * are uploaded individually via POST /photo-uploads and replaced with tiny
 * "psc-store://" references. Keeps save payloads small so photo-heavy
 * inspections never exceed proxy body limits (which surface as endless
 * "network errors" and a stuck sync queue).
 */
import api from "@/lib/api";

const cache = new Map(); // base64 string -> ref (photos are immutable)
const isBig = (p) => typeof p === "string" && p.startsWith("data:image") && p.length > 60000;

export const slimPayload = async (payload, inspectionId = "") => {
  const items = payload?.items || {};
  let changed = false;
  const out = {};
  for (const [k, v] of Object.entries(items)) {
    const photos = (v && v.photos) || [];
    if (!photos.some(isBig)) { out[k] = v; continue; }
    const np = [];
    for (const p of photos) {
      if (!isBig(p)) { np.push(p); continue; }
      if (cache.has(p)) { np.push(cache.get(p)); changed = true; continue; }
      try {
        const r = await api.post("/photo-uploads", { photo: p, inspection_id: inspectionId });
        cache.set(p, r.data.ref);
        np.push(r.data.ref);
        changed = true;
      } catch {
        np.push(p); // upload failed — keep base64, server offloads on save
      }
    }
    out[k] = { ...v, photos: np };
  }
  return changed ? { ...payload, items: out } : payload;
};
